import { doc, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Bulletin } from "../types";

export const getBulletinDetails = async (
  bulletinId: string,
): Promise<Bulletin> => {
  const docRef = doc(db, "bulletins", bulletinId);

  const bulletinSnapshot = await getDoc(docRef);

  return { ...bulletinSnapshot.data(), id: bulletinSnapshot.id } as Bulletin;
};
